import * as yup from "yup";
import { VALID_DATE, TIME_NOT_IN_FUTURE } from "@common/constants/validation";

// Define the validation schema using yup
export const unresolvedDisputeSchema = (optionDisplaySessionsInCompliance) =>
  yup
    .object()
    .shape({
      date: VALID_DATE,
      time: TIME_NOT_IN_FUTURE,
      type: yup.string().required("Type is required"),

      machine: optionDisplaySessionsInCompliance
        ? yup.object().shape({
            installationGuid: yup
              .string()
              .required("Machine installationGuid is required"),
          })
        : yup.object().notRequired(),

      machineReference: !optionDisplaySessionsInCompliance
        ? yup.string().required("Machine reference is required")
        : yup.string().notRequired(),

      description: yup.string().required("Description is required"),

      sessionGuids: optionDisplaySessionsInCompliance
        ? yup.array().required()
        : yup.array().notRequired(),

      cctvCatched: yup
        .boolean()
        .required("Please select yes or no for Captured on CCTV"),
      signature: yup.string().required("Signature is required"),
      customerId: yup.string().nullable(),
      customer: yup.object().nullable(),
    })
    .test(
      "one-of-two",
      "Either customer or customerId must be provided",
      function (value) {
        return value.customer || value.customerId;
      },
    )
    .test(
      "one-of-two",
      "Either phoneNumber or emailAddress must be provided",
      function (value) {
        if (value.customerId) return true;
        return value.customer
          ? value.customer.phoneNumber || value.customer.emailAddress || value.customer.forename
          : false;
      },
    );
